import ObjectiveMcqQuestion from "./subtypes/objectiveMcqQuestion";
import ObjectiveScqQuestion from "./subtypes/objectiveScqQuestion";

import { useAppSelector } from "@assessment/store/store";
interface Props {
  subtype: "mcq" | "scq" | "tf" | "fib";
  options: Record<string, string>;
  answerKey: string[] | undefined;
  updateAnswerKeyHandler: (answerKey: [] | string[]) => void;
  questionId: string;
}
const ObjectiveOptionsInput = ({
  options,
  subtype,
  answerKey,
  updateAnswerKeyHandler,
  questionId,
}: Props) => {
  const randomiseOptions = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData?.randomization?.options
  );

  const shuffledOptionsForQuestions = useAppSelector(
    (state) => state.AssessmentSlice.shuffledOptionsForObjectiveQuestions
  );

  const updatedOptions = randomiseOptions
    ? shuffledOptionsForQuestions[questionId]
    : options;

  if (subtype === "mcq") {
    return (
      <ObjectiveMcqQuestion
        options={updatedOptions}
        updateAnswerKeyHandler={updateAnswerKeyHandler}
        answerKey={answerKey}
      />
    );
  }
  if (subtype === "scq" || subtype === "tf") {
    return (
      <ObjectiveScqQuestion
        options={updatedOptions}
        updateAnswerKeyHandler={updateAnswerKeyHandler}
        answerKey={answerKey}
      />
    );
  }
};

export default ObjectiveOptionsInput;
